// src/pages/admin/AdminLogin.js
// Page de connexion admin connectée à l'API - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import ROUTES from '../../constants/routes';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { loginAdmin } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (!email.trim() || !password.trim()) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    setLoading(true);
    try {
      await loginAdmin(email, password);
      navigate(ROUTES.ADMIN_DASHBOARD);
    } catch (err) {
      setError(err.message || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      justifyContent: 'center',
      padding: '24px',
      maxWidth: '480px',
      margin: '0 auto',
      backgroundColor: theme.bg,
    },
    logoSection: { textAlign: 'center', marginBottom: '40px' },
    logoTitle: { fontSize: '32px', fontWeight: '700', color: theme.gold },
    logoBadge: {
      display: 'inline-block',
      marginTop: '8px',
      padding: '4px 12px',
      backgroundColor: 'rgba(245, 101, 101, 0.15)',
      border: '1px solid rgba(245, 101, 101, 0.3)',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      color: '#F56565',
    },
    form: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: theme.textSecondary },
    input: {
      padding: '14px 16px',
      backgroundColor: theme.bgInput,
      border: `1px solid ${theme.border}`,
      borderRadius: '8px',
      color: theme.textPrimary,
      fontSize: '15px',
      outline: 'none',
    },
    button: {
      padding: '16px',
      backgroundColor: theme.gold,
      border: 'none',
      borderRadius: '10px',
      color: theme.mode === 'light' ? '#FFFFFF' : '#0A0E1A',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
      marginTop: '8px',
    },
    errorText: {
      fontSize: '13px',
      color: '#F56565',
      textAlign: 'center',
      padding: '8px',
    },
    securityNote: {
      marginTop: '24px',
      fontSize: '12px',
      color: theme.textMuted,
      textAlign: 'center',
      lineHeight: '1.5',
    },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Administration | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.logoSection}>
        <div style={styles.logoTitle}>Fynho</div>
        <div style={styles.logoBadge}>🔒 ADMINISTRATION</div>
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>Email administrateur</label>
          <input
            type="email"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@fynho.com"
            autoComplete="off"
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Mot de passe</label>
          <input
            type="password"
            style={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        </div>
        {error && <div style={styles.errorText}>{error}</div>}
        <button
          style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>
      </div>

      <div style={styles.securityNote}>
        🔒 Accès réservé au personnel autorisé.
        <br />
        Toutes les actions sont enregistrées.
      </div>
    </div>
  );
};

export default AdminLogin;